import { Global, css } from '@emotion/react';

const GlobalStyles = () => (
  <Global
    styles={css`
      *::-webkit-scrollbar {
        height: 5px;
      }

      *::-webkit-scrollbar-track {
        background: #2a2d3c;
      }

      *::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 5px;
      }

      *::-webkit-scrollbar-thumb:hover {
        background: #555;
      }

      *::-webkit-scrollbar:vertical {
        width: 5px;
      }
    `}
  />
);

export default GlobalStyles;
